import { useMemo } from 'react';
import { BackgroundProcess, FileData } from 'src/data-capture/hooks/file-uploads/types';
import { useProcessingDataExportDocument } from './useProcessingDataExportDocument';

type MeetingNotes = {
  id: string;
  clientId?: string;
  templateId?: string;
  backgroundProcessId?: string;
  backgroundProcess?: BackgroundProcess;
  createdAt: string;
  templatisedFileId?: number;
  fileName?: string;
  templatisedFile: FileData;
  eventId?: string;
};

type Props = {
  clientId?: string;
  enabled?: boolean;
};

export const useMeetingNotes = ({ clientId, enabled = true }: Props = {}) => {
  const { items, isLoading, isError, error, refetch } = useProcessingDataExportDocument<
    Omit<MeetingNotes, 'isGenerated'>
  >({
    clientId,
    resource: 'meeting-notes',
    enabled,
  });

  const meetingNotes = useMemo(
    () => items.map(notes => ({ ...notes, isGenerated: true })),
    [items],
  );

  return {
    meetingNotes,
    isLoading,
    isError,
    error,
    refetch,
  };
};
